const getAuthenticityToken = (): string => (
  (document.querySelector('[name="csrf-token"]')?.attributes as any)?.content?.value || ''
);

export default getAuthenticityToken;
